module.exports = __webpack_public_path__ + "static/media/signup.9e50c8a1.png";